import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=3dc7135e&scoped=true"
import script from "./VideoEdit.vue?vue&type=script&lang=js"
export * from "./VideoEdit.vue?vue&type=script&lang=js"
import style0 from "./VideoEdit.vue?vue&type=style&index=0&id=3dc7135e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7135e",
  null
  
)

export default component.exports